// import {convertRowsToData} from '../utils/dataUtils'

export default function MultiDataDataController (pages,currentPage) {

  //WARNG, en realidad la currentPage viene Y debe venir en "config" o sea que mejor lo qutiamtos como parametro, no?!?!!?

  
  let currentData
  if(pages.isMulti){
    if(!currentPage || !pages.data.find((p)=>String(p.id)===String(currentPage))) currentPage = pages.data[0].id
    currentData = pages.data.find((p)=>String(p.id)===String(currentPage)).data
  } else {
    currentData = pages.data
  }
  // return dataControllerClass(currentData,config)
  return currentData
}